import React from 'react';

export default function DisabledCheckMark() {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="nonzero" fill="none">
        <circle cx="7.526" cy="7.526" r="7.526" fill="#9DA5AA" />
        <g fill="#F4F5F5">
          <path d="M5.115 3.855l6.184 6.184a.627.627 0 01-.887.887L4.228 4.742a.627.627 0 01.887-.887z" />
          <path d="M11.299 4.742l-6.184 6.184a.627.627 0 01-.887-.887l6.184-6.184a.627.627 0 01.887.887z" />
        </g>
      </g>
    </svg>
  );
}
